<template>
	<div class="login">
		<n-space vertical
			class="login-container"
			@keydown.enter="auth">
			<n-h3 type="info">Вход в панель администратора</n-h3>
			<n-input v-model:value="state.login"
				type="text"
				placeholder="Логин" />
			<n-input v-model:value="state.password"
				type="password"
				placeholder="Пароль" />
			<n-button type="success"
				style="width: 100%;"
				@click="auth">Войти</n-button>
		</n-space>
	</div>
</template>

<script setup>
import { onMounted, reactive } from "vue"
import { useStore } from "vuex"
import { useMessage } from "naive-ui"
import { useCookies } from "vue3-cookies"
import { useRouter, useRoute } from "vue-router"

const { cookies } = useCookies()
const store = useStore()
const message = useMessage()
const router = useRouter()
const route = useRoute()
const state = reactive({
	login: "",
	password: "",
})

const auth = async() => {
	const errors = []
	const login = state.login.length === 0 ? errors.push("Введите логин!") : state.login
	const password = state.password.length === 0 ? errors.push("Введите пароль!") : state.password
	if (errors.length > 0) {
		message.error(errors.join("\n"))
		return false
	}

	const response = await fetch(`${store.state.backend}/users/auth`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			login: login,
			password: password
		})
	})
	if (response.ok) {
		const data = await response.json()
		if (data.status === "success") {
			store.state.admin.token = data.user.token
			store.state.admin.login = data.user.login
			store.state.admin.verified = data.user.verified
			cookies.set("token", data.user.token)
			await router.push("/")
		}
	} else {
		try {
			const data = await response.json()
			message.error(`Ошибка при попытке авторизации: \n ${data.reason}`)
		} catch {
			message.error("Ошибка при попытке авторизации")
		}
	}
}

const tokenAuth = async(token) => {
	const response = await fetch(`${store.state.backend}/users/auth`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ auth_token: token, })
	})
	if (response.ok) {
		const data = await response.json()
		if (data.status === "success") {
			store.state.admin.token = data.user.token
			store.state.admin.login = data.user.login
			store.state.admin.verified = data.user.verified
			cookies.set("token", data.user.token)
			await router.push("/")
		}
	} else {
		try {
			const data = await response.json()
			message.error(`Ошибка при попытке авторизации по токену: \n ${data.reason}`)
		} catch {
			message.error("Ошибка при попытке авторизации по токену")
		}
	}
}

onMounted(() => {
	document.title = "WIKI BLACK RUSSIA: Авторизация"
	if (route.query.token !== undefined) {
		tokenAuth(route.query.token)
	}
})

</script>

<style scoped lang="scss">
.login {
  width: 100%;
  height: 100%;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  &-container {
    width: 270px;
  }
}
</style>